import React from 'react';
import { SideNav } from 'react-sidenav';
import { connect } from 'reflux';
import AppActions from '../../actions/app';
import AppStore from '../../stores/app';
import T from '../misc/t';

require('stylesheets/boilerplate/menu');
const MapMenu = React.createClass({

  mixins: [
    connect(AppStore, 'app'),
  ],

  updateSelection(e) {
    AppActions.setSelected(e.id);
  },

  render() {

    const navi = [
      { id: 'counties', icon: 'fa fa-spinner fa-spin fa-3x fa-fw', text: <T k="menu.counties" />},
      { id: 'zones', icon: 'fa fa-cube', text: <T k="menu.zones" />},
      { id: 'projects', icon: 'fa fa-bar-chart', text: <T k="menu.projects" />},
    ];

    return (
      <div className="sidebar">
        <div className="menu">
            <SideNav navs={navi} navtype="icon-left" onSelection={this.updateSelection} selected={this.state.app.selected} />
            <div className="data-source">
              The data behind this dashboard comes from the <a href="https://www.opendata.go.ke/Natural-Resources/2015-Estimated-Forest-Cover-for-Counties-in-Kenya-/gnxa-6ww5" target="_blank">Kenya Open Data Portal</a>.
            </div>
        </div>
      </div>
    );
  },
});

export default MapMenu;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/boilerplate/mapmenu.jsx
 **/